
























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalRegraIndicacaoIncluir from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalRegraIndicacaoIncluir.vue'

@Component({
  components: {
    ModalRegraIndicacaoIncluir,
  },
})
export default class ModalFinanceiroRegraIndicacao extends Vue {
  $refs!: { tabs: any }
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get mode() { return this.getRegrasDeCalculoStore.modeIndicacao }
  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoIndicacao }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoIndicacao', value }) }

  /** TABS */

  tb: string = 'tab-1'
  get tabs() { return this.tb }
  set tabs(value: string) { this.tb = value }

  async tabChange(e: string) {
    let tab = ''
    switch (e) {
      case 'tab-1':
        tab = 'indicacao'
        break
      default:
        tab = 'indicacao'
    }

    this.$nextTick(async () => {
      if (tab === 'indicacao') {
        //
      }
    })
  }

  get isEdit() {
    return this.getRegrasDeCalculoStore.mode === 'EDIT'
  }

  loadFecharButton: boolean = false
  get loadingFecharButton() { return this.loadFecharButton }
  set loadingFecharButton(value: boolean) { this.loadFecharButton = value }

  async closeModal() {
    this.showModal = false
    this.getRegrasDeCalculoStore.clearRegraIndicacoes()
    await this.getRegrasDeCalculoStore.getIndicacoesAll(this.getRegrasDeCalculoStore.paginacaoIndicacao)
  }

  @Watch('showModal')
  async onShowModalFinanceiroRegraDeCalculo(value: boolean) {
    if (value) {
      this.$refs.tabs.callSlider()
    }

    if (!value) {
      this.getRegrasDeCalculoStore.setModeIndicacao('CREATE')
      this.tabs = 'tab-1'
    }
  }
}
